import Accordion from "@/Components/Front/Blocks/Accordion/Accordion";
import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import ServiceDescription from "@/Components/Front/Blocks/ServiceDescription";
import ServicesHero from "@/Components/Front/Blocks/ServicesHero";
import WebpImage from "@/Components/Front/Blocks/WebpImage";
import WhatWeOffer from "@/Components/Front/Blocks/WhatWeOffer";
import FrontText from "@/Components/Front/FrontText";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { Link } from "@inertiajs/react";
import { useTranslation, Trans } from "react-i18next";

const WarehouseIndustrialLease = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();
    
    let components = {
        1: <Link href={resolveLocaleRoute('front.home', null, i18n.resolvedLanguage)}/>,
        2: <Link href={resolveLocaleRoute('front.home', null, i18n.resolvedLanguage)}/>,
        3: <Link href={resolveLocaleRoute('front.home', null, i18n.resolvedLanguage)}/>,
    }
    if (i18n.resolvedLanguage === 'en') {
        components = {
            1: <Link href={resolveLocaleRoute('front.home', null, i18n.resolvedLanguage)}/>,
            2: <Link href={resolveLocaleRoute('front.home', null, i18n.resolvedLanguage)}/>,
            3: <Link href={resolveLocaleRoute('front.home', null, i18n.resolvedLanguage)}/>,
        }
    }

    let accordionComponents = {
        1: <Link href="/"/>,
        2: <Link href="/"/>,
        3: <Link href="/"/>,
        4: <Link href="/"/>,
        5: <Link href="/"/>,
        6: <Link href="/"/>,
        7: <Link href="/"/>,
        8: <Link href="/"/>,
        9: <Link href="/"/>,
        10: <Link href="/"/>,
    }

    if (i18n.resolvedLanguage === 'en') {
        accordionComponents = {
            1: <Link href="/"/>,
            2: <Link href="/"/>,
            3: <Link href="/"/>,
            4: <Link href="/"/>,
            5: <Link href="/"/>,
            6: <Link href="/"/>,
            7: <Link href="/"/>,
            8: <Link href="/"/>,
            9: <Link href="/"/>,
            10: <Link href="/"/>,
        }
    }

    return (
        <FrontLayout breadcrumbs={[
            { title: t('breadcrumbs.services'), current: false, href: resolveLocaleRoute('front.services') },
            { title: t('breadcrumbs.industrialLease'), current: true },
        ]}>
            <FrontSeoMetaTags seo={seo}/>
            
            <section>
                <ServicesHero icon={'/storage/icons/service-warehouse-icon.svg'} title={t('services.industrialLeaseHeading')} />
                <ServiceDescription contentKey={'services.industrialLeaseEntry'} lng={i18n.resolvedLanguage}>
                    <WebpImage
                        className='rounded-10 mt-5 w-full'
                        sources={[
                            {
                                width: 768,
                                path: '/storage/images/warehouse-industrial-lease-size-530',
                                mime: '/jpg'
                            },
                            {
                                width: 1,
                                path: '/storage/images/warehouse-industrial-lease',
                                mime: 'jpg'
                            }
                        ]}
                        alt={'warehouse-industrial-lease'}
                        fallback={`/storage/images/warehouse-industrial-lease.jpg`}
                        seo={{
                            width: 517,
                            height: 286
                        }}
                    />
                </ServiceDescription>
            </section>
            <section>
                <Container>
                    <Row>
                        <Column>
                            <FrontText className="text-center mb-10 font-domine font-bold text-dark-blue" textSize={'38/43-m-24/27'}>
                                <h2>{t('services.industrialLeaseEntryH2')}</h2>
                            </FrontText>
                        </Column>
                    </Row>
                    <WhatWeOffer itemsKey={`services.industrialLeaseEntryWhatWeOffer`} components={components} />
                </Container>
            </section>
            <section>
                <Container>
                    <Row>
                        <Column>
                            <FrontText className="text-center mb-10 font-domine font-bold text-dark-blue" textSize={'38/43-m-24/27'}>
                                <h2>{t('services.industrialLeaseAccordionH3')}</h2>
                            </FrontText>
                        </Column>
                        <Column xl={8} lg={8} md={10} className={`mx-auto`}>
                            <Accordion contentKey={`services.industrialLeaseAccordionContent`} agents={agents} components={accordionComponents}/>
                        </Column>
                    </Row>
                </Container>
            </section>
            <section className="xl:mt-25 lg:mt-20 md:mt-15 mt-10 xl:mb-c120 lg:mb-25 md:mb-20 mb-15">
                <FrontOurTeamCards agents={agents}/>
            </section>
        </FrontLayout>
    )
}

export default WarehouseIndustrialLease;